export const getAllRoutesUsers = async (
  setRoutesUsers,
  setAuthenticationChecked,
) => {
  const endpoint = "/admin/users/trip/all.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    if (!res.ok) {
      if (res.status === 401) {
        setAuthenticationChecked("UNAUTHORIZED");
      } else if (res.status === 403) {
        setAuthenticationChecked("FORBIDDEN");
      }
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }
    const data = await res.json();
    setRoutesUsers(data.data);
    setAuthenticationChecked("Success");
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked("FORBIDDEN");
    }
  }
};

export const deleteUser = async (userId) => {
  const endpoint = `/admin/users/trip/${userId}/user.json`;
  const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
    method: "DELETE",
  });
  if (!res.ok) {
    throw new Error(`Error ${res.status}: ${res.statusText}`);
  }
  return res.json();
};

export const becomeUser = async (userId) => {
  const endpoint = `/admin/users/trip/${userId}/becomeUser.json`;
  const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error(`Error ${res.status}: ${res.statusText}`);
  }
  return res.json();
};
